// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable import/named */

import { ShaderModule } from "@luma.gl/shadertools";

const fcbmUniformBlock = `\
uniform fcbmUniforms {
	uniform vec4 color1;
	uniform vec4 color2;
	uniform vec4 color3;
	uniform vec4 color4;
	uniform vec4 color5;

	uniform float min;
	uniform float max;

	uniform bool inverse;
} fcbm;
`;

type fcbmModuleProps = {
	color1: [number, number, number, number];
	color2: [number, number, number, number];
	color3: [number, number, number, number];
	color4: [number, number, number, number];
	color5: [number, number, number, number];
	min: number;
	max: number;
	inverse: boolean;
};

export const fcbmModule = {
	name: "fcbm",
	fs: fcbmUniformBlock,
	uniformTypes: {
		color1: "vec4<f32>",
		color2: "vec4<f32>",
		color3: "vec4<f32>",
		color4: "vec4<f32>",
		color5: "vec4<f32>",
		min: "f32",
		max: "f32",
		inverse: "f32",
	},
} as const satisfies ShaderModule<fcbmModuleProps>;

const scbmUniformBlock = `\
uniform scbmUniforms {
	uniform vec4 color1;
	uniform vec4 color2;
	uniform vec4 color3;
	uniform vec4 color4;
	uniform vec4 color5;
	uniform vec4 color6;
	uniform vec4 color7;

	uniform float min;
	uniform float max;

	uniform bool inverse;
} scbm;
`;

type scbmModuleProps = {
	color1: [number, number, number, number];
	color2: [number, number, number, number];
	color3: [number, number, number, number];
	color4: [number, number, number, number];
	color5: [number, number, number, number];
	color6: [number, number, number, number];
	color7: [number, number, number, number];
	min: number;
	max: number;
	inverse: boolean;
};

export const scbmModule = {
	name: "scbm",
	fs: scbmUniformBlock,
	uniformTypes: {
		color1: "vec4<f32>",
		color2: "vec4<f32>",
		color3: "vec4<f32>",
		color4: "vec4<f32>",
		color5: "vec4<f32>",
		color6: "vec4<f32>",
		color7: "vec4<f32>",
		min: "f32",
		max: "f32",
		inverse: "f32",
	},
} as const satisfies ShaderModule<scbmModuleProps>;

const gsUniformBlock = `\
uniform gsUniforms {
	uniform float min;
	uniform float max;

	uniform bool inverse;
} gs;
`;

type gsModuleProps = {
	min: number;
	max: number;
	inverse: boolean;
};

export const gsModule = {
	name: "gs",
	fs: gsUniformBlock,
	uniformTypes: {
		min: "f32",
		max: "f32",
		inverse: "f32",
	},
} as const satisfies ShaderModule<gsModuleProps>;
